import { Form } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';
import ReactStars from 'react-stars';

function StarsField({
  formik,
  name,
  title,
  required,
  type,
  plaintext,
  placeholder,
  description,
  fieldClassName,
  ...props
}) {
  const errors = objectPath.get(formik.errors, name);
  const touched = objectPath.get(formik.touched, name);
  const value = objectPath.get(formik.values, name);

  return (
    <>
      {type !== 'hidden' && title && (
        <Form.Label htmlFor={name}>
          {title}
          {required ? '*' : null}
        </Form.Label>
      )}
      {description && <p className="text-muted small">{description}</p>}
      <div>
        <ReactStars
          value={Number.isInteger(value) ? value / 25 + 1 : 0}
          onChange={(rating) => formik.setFieldValue(name, rating * 25 - 25)}
          count={5}
          half={false}
          size={32}
          edit
          color1="#777777"
          color2="#3438d0"
          className={fieldClassName || 'd-block'}
        />

        {errors && touched ? (
          <div
            className="invalid-feedback d-block"
            style={{ marginTop: -10 }}
            {...(props['data-testid']
              ? { 'data-testid': `${props['data-testid']}-invalid-feedback` }
              : {})}
          >
            {errors}
          </div>
        ) : null}
      </div>
    </>
  );
}

export default connect(StarsField);
